import { camelCase } from 'es-toolkit/compat';

type SnakeCaseKey = `${string}_${string}`;

/**
 * @deprecated use searchParams.get(key) instead
 *
 * ## context
 *    - We upgraded to react-router-dom v6/7 which introduced the useSearchParams hook.
 *    - We deprecated useQueryParams hook from the @betterment/js-runtime package.
 *    - The useQueryParams hook from the @betterment/js-runtime package used to allow reading search params as camelCase regardless of how it's actually defined in the URL.
 *
 * ## the ideal state:
 *    - We want to use the useSearchParams hook from react-router-dom directly.
 *    - We want to move away from any camel or snake case conversion of search params.
 *    - We prefer for our search params to be defined in the URL as snake_case.
 *
 * ## required changes to migrate:
 *    - OLD:`const someSearchParam = getLegacySearchParam(searchParams, 'some_search_param');`
 *    - NEW `const someSearchParam = searchParams.get('some_search_param');`
 *    - MAYBE `const someSearchParam = searchParams.get('someSearchParam')` (use this if the param is defined in the URL as camelCase and changing it to snake_case is not an option)
 *
 */
export const getLegacySearchParam = (searchParams: URLSearchParams, snakeCaseKey: SnakeCaseKey): string | null => {
  const camelCaseKey = camelCase(snakeCaseKey);
  return searchParams.get(camelCaseKey) ?? searchParams.get(snakeCaseKey);
};
